<template>
  <div>
    <header class="page-header">
      <PageTitle/>
      <div class="filters">
        <formulate-input v-model="search" placeholder="Search" type="text" @input="getListData"></formulate-input>
      </div>
    </header>

    <div class="main-content">
      <div class="pane table-pane" :class="{'loading': isLoading}">
        <div class="table-wrapper">
          <div class="table-element">
            <table class="listData" v-if="!isLoading">
              <thead>
              <tr>
                <th :class="(sortBy === 'order.id' ? 'active ' + sortDir : '')" @click="sortTable('order.id')" class="id">
                  <div>ID</div>
                </th>
                <th :class="(sortBy === 'order.budget_pre_order' ? 'active ' + sortDir : '')" @click="sortTable('order.budget_pre_order')">
                  <div>Budget pre order</div>
                </th>
                <th :class="(sortBy === 'order.budget_post_order' ? 'active ' + sortDir : '')" @click="sortTable('order.budget_post_order')">
                  <div>Budget post order</div>
                </th>
                <th :class="(sortBy === 'order.total_price_ex_vat' ? 'active ' + sortDir : '')" @click="sortTable('order.total_price_ex_vat')">
                  <div>Totale prijs ex. btw</div>
                </th>
                <th :class="(sortBy === 'order.created' ? 'active ' + sortDir : '')" @click="sortTable('order.created')">
                  <div>Aangemaakt</div>
                </th>
                <th :class="(sortBy === 'order.dealer_id' ? 'active ' + sortDir : '')">
                  <div>Dealer</div>
                </th>
              </tr>
              </thead>

              <tbody v-if="listData.length > 0">
              <tr @click="$router.push({name: 'admin.b2b_order', params: {id: listObj.id }})" :key="listObj.id" v-for="listObj in listData">
                <td class="id">{{ listObj.id }}</td>
                <td>{{ $n(listObj.budget_pre_order, 'currency', 'nl-BE') }}</td>
                <td>{{ $n(listObj.budget_post_order, 'currency', 'nl-BE') }}</td>
                <td>{{ $n(listObj.total_price_ex_vat, 'currency', 'nl-BE') }}</td>
                <td>{{ listObj.created.toFormat('dd/LL/yyyy') }}</td>
                <td>
                  <RouterLink target="_blank" class="text-wilmsBlue" :to="{ name: 'admin.dealer', params: { id: listObj.dealer.id }}">{{ listObj.dealer.name }}</RouterLink>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination">
            <div class="results">
              {{ total.min }} - {{ total.max }} van {{ listTotal }} b2b orders
            </div>

            <div class="buttons">
              <button class="btn-inverse" :disabled="page === 0" @click="prevPage()">Prev</button>
              <button class="btn-inverse" :disabled="listData.length !== perPage" @click="nextPage()">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiService } from '@/services/admin/api.service'
import PageTitle from '@/components/admin/PageTitle'
import { DateTime } from 'luxon'

export default {
  components: { PageTitle },
  data: function () {
    return {
      isLoading: true,
      search: null,
      listData: [],
      page: 0,
      perPage: 25,
      sortBy: 'order.id',
      sortDir: 'desc',
      listTotal: 0
    }
  },
  async mounted () {
    this.isLoading = true
    await this.getListData()
    this.isLoading = false
  },
  methods: {
    async getListData () {
      await ApiService.fetchB2BOrders({
        page: this.page,
        order_by: this.sortBy,
        order_dir: this.sortDir,
        search: this.search
      }).then(res => {
        this.listData = res.data.orders
        this.listData.map(obj => {
          obj.created = DateTime.fromISO(obj.created)
          return obj
        })
        this.listTotal = res.data.total
      })
    },
    async sortTable (sortBy) {
      if (sortBy === this.sortBy) {
        this.sortDir = (this.sortDir === 'asc' ? 'desc' : 'asc')
      }

      this.sortBy = sortBy

      await this.getListData()
    },
    prevPage: async function () {
      if (this.page > 0) {
        this.page--
        await this.getListData()
      }
    },
    nextPage: async function () {
      if (this.listData.length === this.perPage) {
        this.page++
        await this.getListData()
      }
    }
  },
  computed: {
    total: function () {
      const offsetMax = this.perPage * (this.page + 1)
      const offsetMin = offsetMax - this.perPage + 1

      return {
        min: offsetMin,
        max: offsetMax > this.listTotal ? this.listTotal : offsetMax
      }
    }
  }
}
</script>
